import styled from "styled-components";
import { rgba } from "polished";
const ClusteredAvatarsWrapper = styled("div")(({ theme }) => ({
  alignItems: "center",
  color: theme.color.default,
  display: "flex",
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  fontWeight: theme.fontWeight.normal,
  lineHeight: theme.lineHeight.default,
  transformStyle: "preserve-3d"
}));
const ClusteredAvatarsItem = styled("div")(
  {
    flex: "0 0 auto"
  },
  ({ index }) => ({
    transform: `translateZ(${-index}px)`
  }),
  ({ index, magnitude }) => index > 0 ? {
    marginLeft: {
      xsmall: -3,
      small: -4,
      medium: -5,
      large: -8,
      xlarge: -11
    }[magnitude]
  } : void 0
);
const ClusteredAvatarsRemainder = styled("div")({
  color: rgba("black", 0.45),
  paddingLeft: "0.5em"
});
export {
  ClusteredAvatarsItem,
  ClusteredAvatarsRemainder,
  ClusteredAvatarsWrapper
};
